"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriveCalc = void 0;
var DriveCalc;
(function (DriveCalc) {
    var RouteStatus;
    (function (RouteStatus) {
        RouteStatus[RouteStatus["UNFINISHED"] = 0] = "UNFINISHED";
        RouteStatus[RouteStatus["INCOMPLETE"] = 0] = "INCOMPLETE";
        RouteStatus[RouteStatus["FINISHED"] = 1] = "FINISHED";
        RouteStatus[RouteStatus["COMPLETE"] = 1] = "COMPLETE";
    })(RouteStatus = DriveCalc.RouteStatus || (DriveCalc.RouteStatus = {}));
    function isUnFinished(route) {
        return route.status === RouteStatus.UNFINISHED;
    }
    DriveCalc.isUnFinished = isUnFinished;
    function isFinished(route) {
        return route.status === RouteStatus.FINISHED;
    }
    DriveCalc.isFinished = isFinished;
    /**
     * This calculates the quota and cost for each stop. Using Zwick algorithm.
     *
     * @param distanceDriven The actual driven distance, either manually submitted by user or retrieved from Google Maps
     * @param unfinishedRoute The unfinished route object
     * @param config The config object
     */
    function processRoute(distanceDriven, unfinishedRoute, config) {
        var preProcessedStops = unfinishedRoute.stops.map(function (_a) {
            var location = _a.location, clientCount = _a.clientCount, note = _a.note;
            var address = location.address, name = location.name, coordinates = location.coordinates, distance = location.distance;
            return __assign(__assign({ clientCount: clientCount }, (note && { note: note })), { location: {
                    address: address,
                    name: name,
                    coordinates: coordinates,
                    distance: distance,
                } });
        });
        var totalTheoreticalDistance = preProcessedStops.reduce(function (total, currentValue) {
            return total + currentValue.location.distance;
        }, 0);
        var totalPrice = distanceDriven * config.distancePrice;
        var stops = preProcessedStops.map(function (stop) {
            var quota = stop.location.distance / totalTheoreticalDistance;
            var cost = totalPrice * quota;
            var costPerClient = Math.max(config.minimumPrice, cost / stop.clientCount);
            return __assign(__assign({}, stop), { quota: quota, cost: cost, costPerClient: costPerClient });
        });
        return __assign(__assign({}, unfinishedRoute), { distanceDriven: distanceDriven, stops: stops, status: RouteStatus.FINISHED });
    }
    DriveCalc.processRoute = processRoute;
})(DriveCalc = exports.DriveCalc || (exports.DriveCalc = {}));
